import React from 'react'
import './mobile-slider.scss'
import LeftIco from '../../../f/svg/left.svg'
import RightIco from '../../../f/svg/right.svg'
import Mobile from '../../../f/img/target/mobile.png'

const MobileSlider = ({ worksId: worksIdProp, className, nextColor }) => {
    const itemsRef = React.useRef([])
    const slider = React.useRef()
    const currentIndex = React.useRef(0)

    const [worksId, setWorksId] = React.useState(worksIdProp || [])
    const [loading, setLoading] = React.useState(!worksIdProp)
    const [activeIndex, setActiveIndex] = React.useState(0)

    const [worksData, setWorksData] = React.useState([])

    const isWhite = ({ r, g, b }) => r * 0.299 + g * 0.587 + b * 0.114 <= 186

    React.useEffect(() => {
        const load = async () => {
            const data = await Promise.all(
                worksId.map((ids) => {
                    let url = 'https://www.artlebedev.ru/svalka/api/2019/?lang_id=1'
                    url += '&data=works'
                    url += `&works_custom_ids=${ids}`
                    url += '&works_custom_ids_sort=1'
                    url += '&works_offset=0&works_limit=30&works_not_update_price=1'
                    return fetch(url).then(r => r.json())
                })
            )
            setWorksData(data)
        }
        load()
    }, [])

    const renderMedia = (work) => {
        if (window.innerWidth < 900) {
            return (<img src={work.img} className='anons-image' />)
        }
        if (work.preview.type == 'image') {
            return (
                <img src={work.preview.src} className='anons-image' />
            )
        }
        else if (work.preview.type == 'video') {
            return (
                <video autoPlay muted loop poster={work.preview.data.poster} className='anons-image'>
                    {work.preview.data.video.map((video, i) => (
                        <source key={video.src || i} src={video.src} type={video.type} />
                    ))}
                </video>
            )
        }
        else {
            return (<img src={work.img} className='anons-image' />)
        }
    }

    const openAnons = (index) => {
        console.log(index)
    }

    const handleItemClick = (index, url) => {
        const length = itemsRef.current.length
        const currentActive = currentIndex.current
        
        if (index === (currentActive - 1 + length) % length) {
            slide(-1)
        } else if (index === (currentActive + 1) % length) {
            slide(1)
        } else if (index === (currentActive - 2 + length) % length) {
            slide(-2)
        } else if (index === (currentActive + 2) % length) {
            slide(2)
        } else if (index === (currentActive + length) % length) {
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.click();
        }
    }

    const updateClasses = React.useCallback((index) => {
        const length = itemsRef.current.length
        if (!length) return

        const protoLeft = (index - 3 + length) % length
        const leftPrevIndex = (index - 2 + length) % length
        const prevIndex = (index - 1 + length) % length
        const nextIndex = (index + 1) % length
        const rightNextIndex = (index + 2) % length
        const protoRight = (index + 3) % length

        itemsRef.current.forEach((item, i) => {
            if (!item) return

            item.classList.toggle('active', i === index)
            item.classList.toggle('prev', i === prevIndex)
            item.classList.toggle('next', i === nextIndex)
            item.classList.toggle('prev-prev', i === leftPrevIndex)
            item.classList.toggle('next-next', i === rightNextIndex)
            item.classList.toggle('proto-left', i === protoLeft)
            item.classList.toggle('proto-right', i === protoRight)
            item.classList.toggle(
                'hidden',
                i !== index &&
                i !== prevIndex &&
                i !== nextIndex && 
                i !== leftPrevIndex && 
                i !== rightNextIndex
            )
        })
    }, [])

    const slide = React.useCallback((direction) => {
        if (!slider.current || !itemsRef.current.length) {
            return
        }

        const length = itemsRef.current.length

        slider.current.classList.remove('left', 'right')
        slider.current.classList.remove('moving')
        slider.current.classList.add(direction < 0 ? 'left' : 'right')

        setTimeout(() => {
            slider.current.classList.add('moving')
        }, 50)

        currentIndex.current = (currentIndex.current + direction + length) % length

        setActiveIndex(currentIndex.current)
        updateClasses(currentIndex.current)
    }, [updateClasses])

    React.useLayoutEffect(() => {
        if (!itemsRef.current.length) return
        currentIndex.current = 0
        setActiveIndex(0)
        updateClasses(0)
    }, [worksData, updateClasses])

    if (loading || !worksId.length) {
        return null
    }

    return (
        <div 
            className={`slider-portfolio ${className || ''}`} 
            ref={slider} 
            id='mobile-slider'
            style={{ '--next-color': nextColor || "black" }}
        >

            <img src={Mobile} className='phone-image' />

            {worksData.length >= 2 && (
                <>
                    <div className='arrow left' onClick={() => slide(-1)}>
                        <img src={LeftIco} alt='Назад' />
                    </div>

                    <div className='mini-slider'>
                        {worksData.map((_, i) => (
                            <div
                                key={i}
                                className={`mini-slider-item ${i === activeIndex ? 'active' : ''}`}
                            />
                        ))}
                    </div>

                    <div className='arrow right' onClick={() => slide(1)}>
                        <img src={RightIco} alt='Вперед' />
                    </div>
                </>
            )}

            {Array.isArray(worksData) && worksData.map((item, i, arr) => (
                <div
                    key={i}
                    className={`portfolio-item ${i === 0 ? 'active' : 'hidden'}`}
                    ref={el => itemsRef.current[i] = el}
                >
                    {item.works?.list && item.works?.list.map((work) => (
                        <div key={work.id || work.url} className={`anons-item-wrapper anons-size-${work.type}`}>
                            <div
                                className='anons-item'
                                onClick={() => handleItemClick(i, work.url)}
                            >
                                {renderMedia(work)}
                                <div
                                    className={`anons-title ${isWhite(work.img_color) ? 'white-color' : 'black-color'
                                        }`}
                                    style={{
                                        '--r': work.img_color.r,
                                        '--g': work.img_color.g,
                                        '--b': work.img_color.b
                                    }}
                                ><span dangerouslySetInnerHTML={{ __html: work.title }} /></div>
                            </div>
                        </div>
                    ))}
                </div>
            ))}

        </div>
    )
}

export default MobileSlider